/*global autocomplete, dates, inputDirectionChange */

var pickDL = {
    options: {},
    pickDate: '',
    init: function() {
        pickDL.clickToOpen();
        pickDL.closeAction();
    },
    clickToOpen: function() {
        $('body').on('click', '.open-pick-modal', function(e) {
            e.preventDefault();
            var url = $(this).data('url');
            pickDL.openModal(url);
        });
    },
    fixArabicNumbers: function(dateText) {
        return dateText.replace(/[٠-٩]/g, function(d) {
            return '٠١٢٣٤٥٦٧٨٩'.indexOf(d);
        });
    },
    openModal: function(url) {

        var mWindow = $('.pick-modal'),
            mBody = $('.pick-modal-body'),
            mLoadData = $('.pick-modal-load-data'),
            pBody = '';

        mWindow.fadeIn(400);
        mWindow.removeClass().addClass('pick-modal');
        $('body').addClass('pick-modal-open');

        mLoadData.show();
        mBody.html('');

        $.getJSON(url, function(response) {
            if (response.error) {
                pBody = response.message;
            } else {
                pBody = response.data.body;
            }

            setTimeout(function() {
                autocomplete.init('modal');
                pickDL.select();
                pickDL.isDropOff();
                pickDL.calendar();
                pickDL.age();
                pickDL.residence();
                pickDL.submit();

                var pickupFieldSelectors = '#pick-up-location, #drop-off-location';
                inputDirectionChange.onChangeAction(pickupFieldSelectors);

                mWindow.find('#sb-country').attr('id', 'sb-country-modal');
                mWindow.find('#sb-age').attr('id', 'sb-age-modal');

                var age = $('#age-tooltip');
                age.qtip({
                    position: {
                        my: 'bottom center',
                        at: 'top center'
                    },
                    content: {
                        text: '<span class="qtip-arrow"></span>' + age.attr('data-tooltip')
                    }
                });

            }, 0);

            mLoadData.hide();
            mBody.html(pBody);
            mBody.show();
        });

    },
    select: function() {
        var timeOptions = {
            inherit_select_classes: true,
            disable_search: true,
            no_results_text: _d.t.chosen_no_results_text,
            width: '100%'
        };

        var chosenConfig = {
            '#pick-time-modal': timeOptions,
            '#drop-time-modal': timeOptions
        };

        for (var selector in chosenConfig) {
            if (Object.prototype.hasOwnProperty.call(chosenConfig, selector)) {
                var selectHandler = $(selector),
                    selectVal = selectHandler.val();

                selectHandler.chosen(chosenConfig[selector]);

                if (selectVal > 0) {
                    selectHandler.next().addClass('selected');
                } else {
                    selectHandler.next().addClass('choose');
                }
            }
        }

        $('.time-select').on('change', function() {
            $('.time-select').next().removeClass('err');
            $('.inline-error').slideUp();

            var that = $(this);

            that.addClass('selected');

            if (that.attr('id') === 'pick-time-modal' && $('#drop-time-modal').val() === '0') {
                $('#drop-time-modal').val(that.val()).trigger('chosen:updated');
            }

            if (that.attr('id') === 'drop-time-modal' && $('#pick-time-modal').val() === '0') {
                $('#pick-time-modal').val(that.val()).trigger('chosen:updated');
            }

            if (that.attr('id') === 'pick-time-modal' && !$('#drop-date-modal-ui').hasClass('selected')) {
                $('#drop-date-modal-ui').datepicker('show');
            }
        }).on('chosen:showing_dropdown', function(e) {
            var time = $(e.target);
            if (time.val() === '0') {
                time.next('.chosen-container').find('.chosen-results').scrollTop(40 * 12);
            }
        });
    },
    isDropOff: function() {
        $('#is-drop-off-modal').on('click', function() {
            var dropOffHandler = $(this).closest('form').find('.sb-group.drop-off');
            if ($(this).prop('checked')) {
                dropOffHandler.css({
                    'position': 'absolute',
                    'visibility': 'hidden'
                });
                dropOffHandler.hide();
            } else {
                var dropCountry = $('#drop-modal-country'),
                    dropCity = $('#drop-modal-city'),
                    dropPlace = $('#drop-modal-place'),
                    dropCountryValue = parseInt(dropCountry.val()),
                    dropCityValue = parseInt(dropCity.val());

                dropCountry.prop('disabled', false).trigger('chosen:updated');

                if ($('#pick-modal-place').val() > 0 && dropCountryValue === 0) {
                    dropCountry.next().addClass('choose');
                }
                if (dropCountryValue > 0) {
                    dropCity.prop('disabled', false).trigger('chosen:updated');
                }
                if (dropCityValue > 0) {
                    dropPlace.prop('disabled', false).trigger('chosen:updated');
                }

                dropOffHandler.css({
                    'position': 'static',
                    'visibility': 'visible'
                });
                dropOffHandler.show();
            }
        });
    },
    calendar: function() {

        let dateFormat = _d.specificDateFormats[_d.s.language] ? _d.specificDateFormats[_d.s.language] : null;

        if (dateFormat === null) {
            dateFormat = (_d.s.language === 'en' ? (_d.sbm ? 'M d, yy' : 'D, M d, yy') : (_d.sbm ? 'd M, yy' : 'D, d M, yy'));
        }

        $('.date-field.in-modal').each(function() {
            var that = $(this),
                elementID = '#' + that.attr('id').replace('-ui', ''),
                parsedDate = $.datepicker.parseDate('yy-mm-dd', $(elementID).val()),
                newDate = $.datepicker.formatDate(dateFormat, parsedDate, {
                    dayNames: _d.t.datepicker_weekdays_full,
                    dayNamesShort: _d.t.datepicker_weekdays_short,
                    dayNamesMin: _d.t.datepicker_weekdays_short,
                    monthNames: _d.t.datepicker_months_full,
                    monthNamesShort: _d.t.datepicker_months_short
                });

            that.datepicker({
                firstDay: 1,
                altField: elementID,
                altFormat: 'yy-mm-dd',
                numberOfMonths: 2,
                showButtonPanel: false,
                dateFormat: dateFormat,
                prevText: '',
                nextText: '',
                minDate: new Date(new Date().getTime()),
                dayNames: _d.t.datepicker_weekdays_full,
                dayNamesShort: _d.t.datepicker_weekdays_short,
                dayNamesMin: _d.t.datepicker_weekdays_short,
                monthNames: _d.t.datepicker_months_full,
                monthNamesShort: _d.t.datepicker_months_short,
                beforeShow: function(input, inst) {
                    $(input).val(pickDL.fixArabicNumbers($(input).val()));
                    var pickDateHandler = $('#pick-date-modal-ui');

                    pickDL.pickDate = $('#pick-date-modal').val();

                    that.addClass('active');

                    setTimeout(function() {
                        if (window._d.isRTL) {
                            inst.dpDiv.css({
                                top: pickDateHandler.offset().top + $('#ui-datepicker-div').height,
                                right: pickDateHandler.offset().right
                            });
                        } else {
                            inst.dpDiv.css({
                                top: pickDateHandler.offset().top + $('#ui-datepicker-div').height,
                                left: pickDateHandler.offset().left
                            });
                        }


                        if (inst.dpDiv.position().top > $(input).position().top) {
                            inst.dpDiv
                                .removeClass('ui-above')
                                .addClass('ui-below');
                        } else {
                            inst.dpDiv
                                .removeClass('ui-below')
                                .addClass('ui-above');
                        }
                    }, 0);
                },
                beforeShowDay: function(date) {
                    var dropDate,
                        pickDateHandler = $('#pick-date-modal-ui'),
                        dropDateHandler = $('#drop-date-modal-ui'),
                        parsedDate = pickDL.parseDate(date);

                    if (that.attr('id') === 'pick-date-modal-ui') {
                        if (pickDateHandler.hasClass('selected')) {
                            dropDate = dropDateHandler.datepicker('getDate');

                            if (dropDate !== null) {
                                dropDate = pickDL.parseDate(dropDate);

                                if (dropDate && parsedDate === dropDate) {
                                    return [true, 'ui-state-pickup-date', ''];
                                } else if (pickDL.pickDate && dropDate && dates.compare(parsedDate, pickDL.pickDate) > 0 && dates.compare(parsedDate, dropDate) < 0) {
                                    return [true, 'ui-state-pickup-dates', ''];
                                }
                            }
                        }

                        return [true, '', ''];
                    } else if (dropDateHandler.hasClass('selected')) {
                        if (pickDL.pickDate && parsedDate === pickDL.pickDate) {
                            return [true, 'ui-state-pickup-date', ''];
                        } else {
                            dropDate = $('#drop-date').val();
                            if (pickDL.pickDate && dropDate && dates.compare(parsedDate, pickDL.pickDate) > 0 && dates.compare(parsedDate, dropDate) < 0) {
                                return [true, 'ui-state-pickup-dates', ''];
                            }
                        }
                    }

                    return [true, '', ''];
                },
                onSelect: function(dateStr) {
                    dateStr = pickDL.fixArabicNumbers(dateStr);
                    var pickDateHandler = $('#pick-date-modal-ui'),
                        dropDateHandler = $('#drop-date-modal-ui'),
                        dropDate = '';

                    $('.time-select.err').removeClass('err');
                    $('.inline-error').slideUp();

                    if (that.attr('id') === 'pick-date-modal-ui') {

                        if (!$('#pick-time-modal').hasClass('selected')) {
                            setTimeout(function() {
                                $('#pick-time-modal').trigger('chosen:open');
                            }, 400);
                        }

                        dropDate = that.datepicker('getDate');

                        if (dropDateHandler.datepicker('getDate') < pickDateHandler.datepicker('getDate')) {
                            dropDate.setDate(dropDate.getDate());

                            dropDateHandler.datepicker('option', 'defaultDate', dropDate);
                            dropDateHandler.datepicker('option', 'minDate', dateStr);

                            if ($('#pick-time-modal').hasClass('selected')) {
                                setTimeout(function() {
                                    dropDateHandler.datepicker('show');
                                }, 400);
                            }
                        } else {
                            dropDateHandler.datepicker('option', 'minDate', dateStr);
                        }
                        pickDateHandler.addClass('selected');
                    } else {
                        dropDateHandler.addClass('selected');

                        if (dropDateHandler.datepicker('getDate') < pickDateHandler.datepicker('getDate')) {
                            pickDateHandler.datepicker('setDate', dateStr);
                        }
                    }
                },
                onClose: function() {
                    that.removeClass('active');
                }
            }).val(newDate);
            $('.ui-datepicker').addClass('notranslate');

        });
    },
    openPickTime: function() {
        if (!$('#pick-time-modal').hasClass('selected')) {
            setTimeout(function() {
                $('#pick-time-modal').trigger('chosen:open');
            }, 400);
        }
    },
    parseDate: function(date) {
        date = new Date(date);
        return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
    },
    age: function() {

        $('.pick-modal').on('click', '#sb-age-modal', function(e) {
            e.stopPropagation();

            var that = $(this),
                age = $('.age-select'),
                list = $('.age-select-list'),
                offsetLeft = that.offset().left - 12;

            age.removeClass('closed');
            $('.residence-select').addClass('closed');

            var listTop = that.offset().top - age.outerHeight() - 12;

            if ($(window).scrollTop() > listTop) {
                age.offset({
                    top: that.offset().top + that.outerHeight() + 12,
                    left: offsetLeft
                }).addClass('bottom');
            } else {
                age.offset({
                    top: listTop,
                    left: offsetLeft
                }).removeClass('bottom');
            }

            if (!list.hasClass('positioned')) {
                list.animate({
                    scrollTop: $('.age-select-list li.selected').offset().top
                }, 0, function() {
                    $('.age-select-list').addClass('positioned');
                });
            }
        });

        $('.age-select-list li').on('click', function(e) {
            e.stopPropagation();

            var that = $(this),
                val = that.data('value');

            $('.age-select-list li').removeClass('selected');
            that.addClass('selected');
            $('.age-select').addClass('closed');
            $('#sb-age-modal').text(val);
            $('#driver-age-input-modal').val(val);
        });

        $(document).keyup(function(e) {
            if (e.keyCode === 27) {
                $('.age-select').addClass('closed');
            }
        });
    },
    residence: function() {
        $('#sb-residence-modal').chosen({
            inherit_select_classes: true,
            placeholder_text_single: _d.t.please_select_country,
            no_results_text: _d.t.chosen_no_results_text,
            max_selected_options: 1,
            search_contains: true,
            width: '270px'
        }).on('change', function() {
            $('#sb-country-modal').text($('#sb-residence-modal option:selected').text());
        }).on('chosen:showing_dropdown', function(event) {
            $(event.target).next('.chosen-container').addClass('chosen-drop-up');
        }).on('chosen:hiding_dropdown', function() {
            $('.residence-select').addClass('closed').click();
        });

        $('.residence-select .chosen-search').on('click', function(e) {
            e.stopPropagation();
        });

        $('.pick-modal').on('click', '#sb-country-modal', function(e) {
            e.stopPropagation();

            var that = $(this),
                residence = $('.residence-select'),
                offsetLeft = that.offset().left - 12,
                listTop = that.offset().top - residence.outerHeight() - 14;

            residence.removeClass('closed');
            $('.age-select').addClass('closed');

            residence.offset({
                top: listTop,
                left: offsetLeft
            }).removeClass('bottom');

            $('#sb-residence-modal').trigger('chosen:open');
        });
    },
    submit: function() {

        $('#sb-form-submit-modal').on('click', function(e) {
            e.preventDefault();

            $('#sb-form-submit-modal').addClass('loading');

            var dateFrom = $('#pick-date-modal').val() + ' ' + $('#pick-time-modal').val(),
                dateTill = $('#drop-date-modal').val() + ' ' + $('#drop-time-modal').val(),
                placePick = $('#pick-place-modal').val(),
                placeDrop = $('#drop-place-modal').val(),
                countryID = $('#pick-country-modal').val(),
                driverAge = $('#driver-age-input-modal').val();

            if (driverAge === '30-65' || driverAge === '65-30') {
                driverAge = '35';
            } else if (driverAge === '80+') {
                driverAge = '80';
            }

           var post = {
                is_drop_off: ($('#is-drop-off-modal').is(':checked') ? 0 : 1),
                driver_age: driverAge,
                pick_up_country_id: countryID,
                pick_up_city_id: $('#pick-city-modal').val(),
                pick_up_location_id: placePick,
                drop_off_country_id: $('#drop-country-modal').val(),
                drop_off_city_id: $('#drop-city-modal').val(),
                drop_off_location_id: placeDrop,
                pickup_id: placePick,
                dropoff_id: placeDrop,
                pickup_from: dateFrom,
                pickup_to: dateTill,
                pick_time: $('#pick-time-modal').val(),
                drop_time: $('#drop-time-modal').val(),
                luxOnly: _d.s.luxOnly,
                residence_country: $('#sb-residence-modal').val(),
                partner_id: $('#partner-id-modal').val(),
                another_country: $('#sb-another').val()
            };

            $.post(_d.url.search.createSearch, post, function(response) {
                if (response.success) {
                    document.location.href = response.data.url;
                } else {
                    var errorHandler = $('.inline-error.in-modal');

                    $('#sb-form-submit-modal').removeClass('loading');
                    errorHandler.html('').append('<ul id="error-list-modal"></ul>');

                    $.each(response.errors.message, function(index) {
                        if (typeof response.errors.message[index] !== 'undefined') {
                            $('#error-list-modal').append('<li>' + response.errors.message[index] + '</li>');
                        }
                    });

                    $.each(response.errors.fields, function(index, value) {
                        $('#' + value + '-modal').addClass('err');
                    });

                    errorHandler.slideDown();
                }
            }, 'json');
        });
    },
    closeAction: function() {

        $(document).keyup(function(e) {
            if (e.keyCode === 27) {
                $('.pick-modal-close').trigger('click');
            }
        });

        $('.pick-modal-close').on('click', function(e) {
            e.preventDefault();
            pickDL.close();
        });
    },
    close: function() {
        $('.pick-modal').fadeOut(400, function() {
            $('body').removeClass('pick-modal-open');
            $('.modal-body').hide();
        });
    }
};
